module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-page",
    attrs: {
      "id": "chart-map-demo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b75de4c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/demo_map.vue
// module id = 967
// module chunks = 1